/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
export var LookupErrorCode;
(function (LookupErrorCode) {
    LookupErrorCode[LookupErrorCode["Success"] = 0] = "Success";
    LookupErrorCode[LookupErrorCode["FieldNotFound"] = 1] = "FieldNotFound";
    LookupErrorCode[LookupErrorCode["FieldHasNoEntity"] = 2] = "FieldHasNoEntity";
    LookupErrorCode[LookupErrorCode["InternalServerError"] = 3] = "InternalServerError";
    LookupErrorCode[LookupErrorCode["MissingPermissions"] = 4] = "MissingPermissions";
    LookupErrorCode[LookupErrorCode["FeatureDisabled"] = 5] = "FeatureDisabled";
})(LookupErrorCode || (LookupErrorCode = {}));
